module.exports = __webpack_public_path__ + "static/media/o2o_app01.400edeee.png";